import { actionsTypes } from '../constants/loadMenuDataConstants'
import { colors } from '../constants/colors'
import { fetchApiFail, fetchApiSuccess } from '../actions/loadMenuDataActions'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'

function validateIPAddress(ipAddress) {
  return (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress))
}

function isValidUrl(url) {

  if (!url) {
    return true
  }

  try {
    new URL(url)
  } catch (_) {
    return false
  }

  return true
}


function getClientContext() {
  const hostname = window.location.hostname
  let clientContext
  if (validateIPAddress(hostname)) {
    clientContext = 'localhost'
  } else {
    clientContext = hostname.split('.')[0]
  }
  return clientContext
}

function getUrlResource(storeCode, resourceName) {
  return `${process.env.PUBLIC_URL}/content/${getClientContext()}/${storeCode}/${resourceName}`
}

const fetchMenuDataContent = (storeCode) => () => {
  return axios.get(getUrlResource(storeCode, 'content.json'))
    .then(res => res.data)
}

function uuid_v4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      // eslint-disable-next-line no-mixed-operators
      v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}


function processNavigationProducts(navigation, products, storeCode) {
  const navigationResult = {
    'id': navigation.id,
    'order': navigation.order,
    'imgUrl': isValidUrl(navigation.imgUrl) ? navigation.imgUrl : getUrlResource(storeCode, navigation.imgUrl),
    'title': navigation.title,
    'products': [],
    'allProducts': []
  }

  const productsResult = []

  if (navigation.products) {
    navigation.products.forEach(productCode => {
      const product = products.find(prod => prod.productCode === productCode)
      if (product) {
        const productData = {
          ...product,
          'uuid': uuid_v4(),
          'imgUrl': isValidUrl(product.imgUrl) ? product.imgUrl : getUrlResource(storeCode, product.imgUrl),
          'navigationId': navigation.id
        }
        productsResult.push(productData)
        navigationResult.products.push(productData)
      }
    })
  }

  if (navigation.children) {
    const children = []

    const sortedChildren = navigation.children

    sortedChildren.forEach(nav => {
      const [navigation, navigationProducts] = processNavigationProducts(nav, products, storeCode)
      children.push(navigation)
      productsResult.push(...navigationProducts)
    })

    navigationResult.children = children
  }

  navigationResult.allProducts = productsResult

  return [navigationResult, productsResult]
}

function processDigitalMenuData(data, storeCode) {
  const result = {
    'products': [],
    'navigations': [],
    'colors': {
      'primary': colors.DEFAULT_PRIMARY_COLOR,
      'secondary': colors.DEFAULT_SECONDARY_COLOR
    },
    tags: []
  }

  const products = data.products || []

  if (data.navigation) {
    result.colors.primary = data.navigation.color || colors.DEFAULT_PRIMARY_COLOR

    if (data.navigation.children) {
      const sortedNavigations = data.navigation.children

      sortedNavigations.forEach(n => {
        const [navigation, navigationProducts] = processNavigationProducts(n, products, storeCode)

        result.navigations.push(navigation)
        result.products.push(...navigationProducts)
      })

      const tagsSet = new Set()
      if (result.products) {
        result.products.forEach(product => {
          if (product.tags) {
            product.tags.forEach(tag => tagsSet.add(tag))
          }
        })
        result.tags = [
          ...tagsSet
        ]
      }
    }
  }

  return result
}

function* requestFetchFromApi(action) {
  try {
    const data = yield call(fetchMenuDataContent(action.storeCode))
    yield all([
      put(fetchApiSuccess(processDigitalMenuData(data, action.storeCode))),
    ])
  } catch (error) {
    yield all([
      put(fetchApiFail(error)),
    ])
  }
}

export default function* loadMenuSaga() {
  yield takeLatest(actionsTypes.LOADING_DATA_REQUESTED, requestFetchFromApi)
}
